import { defineStore } from 'pinia';
import { OverageService } from '@/services';
import { OverageStateInterface } from '@/types';
import { useDateTime } from '@/composables';

export default defineStore('OverageStore', {
  state: (): OverageStateInterface => ({
    overage_list: [],
    dashboard_overages: [],
    scheduled_over: false,
    completed_over: false,
    date: new Date(),
    show_seats_modal: false,
    message: '',
    error: false,
    loading: {
      organization: false,
      modal: false,
      overage: false,
    },
  }),
  getters: {},
  actions: {
    async getOverages(date: Date, ids: string[] = []) {
      this.loading.overage = true;
      const apiDate = useDateTime().formatDateForApi(date);
      try {
        const response = await OverageService.getOverages(apiDate, ids);

        if (response.data) {
          this.dashboard_overages = response.data.data;
        }
        //eslint-disable-next-line
      } catch (e: any) {
        this.catchError(e);
      }
      this.loading.overage = false;
    },
    async getOrganizationOverages(id: number, date: Date, shouldLoadOverage: boolean) {
      const apiDate = useDateTime().formatDateForApi(date);
      try {
        const response = await OverageService.getOrganizationOverages(id, apiDate);

        if (response.data) {
          this.overage_list = response.data.data;
          if (shouldLoadOverage === true) {
            this.scheduled_over = response.data.meta.scheduled_over;
            this.completed_over = response.data.meta.completed_over;
            this.show_seats_modal = true;
          }
        }
        //eslint-disable-next-line
      } catch (e: any) {
        if (e.data.message.includes('Overages do not apply')) {
          if (shouldLoadOverage) this.show_seats_modal = false;
          else if (this.loading.modal) {
            this.overage_list = [];
            this.loading.modal = false;
          }
        } else this.catchError(e);
      }
    },
    //eslint-disable-next-line
    catchError(e: any) {
      this.error = true;
      this.loading.modal = this.loading.organization = this.loading.overage = false;
      this.message = e.data.message ? e.data.message : 'There was an error. Please try again';
      this.doToast(this.message, 'Error', this.error);
      throw e;
    },
    loaded() {
      this.loading.modal = this.loading.organization = this.loading.overage = false;
      this.error = false;
      this.message = '';
    },
  },
});
